<template>
  <div>
    <div class="masklist" style="margin-top:35px">
      <div class="chooseLabel">
        <span class="masktitle">{{ $t("exhibitor.chooseLabel") }}</span>
      </div>
      <div>
        <div class="masklabel">
          <template v-for="(item, index) in productType">
              <p v-for="(_item, _index) in item.child" :key="_item.id">
                <span
                  v-if="langSet == 'zh'&&_item.show"
                  :class="[_item.show ? 'active' : '']"
                  @click.stop="levelClick(_item,index,_index)"
                >{{ _item.name }}</span>
                <span
                  v-if="langSet == 'en'&&_item.show"
                  :class="[_item.show ? 'active' : '']"
                  @click.stop="levelClick(_item,index,_index)"
                >{{ _item.description }}</span>
              </p>
          </template>
          <!-- <p v-if="ToChoose.index>-1">
            <span
              v-if="langSet == 'zh' || ToChoose.content.description.length == 0"
              :class="[subMenuid == ToChoose.content.linkageid ? 'active' : '']"
              @click="levelClick(ToChoose.content,ToChoose.index,ToChoose._index)"
            >{{ ToChoose.content.name }}</span>
            <span
              v-if="langSet == 'en' && ToChoose.content.description.length > 0"
              :class="[subMenuid == ToChoose.content.linkageid ? 'active' : '']"
              @click="levelClick(ToChoose.content,ToChoose.index,ToChoose._index)"
            >{{ ToChoose.content.description }}</span>
          </p>-->
          <p v-if="Tocountry.index>-1">
            <span
              v-if="langSet == 'zh' || Tocountry.content.en_country.length == 0"
              :class="[countrytext == Tocountry.content.country ? 'active' : '']"
              @click="chooseCList(Tocountry.content.country,Tocountry.content,Tocountry.index)"
            >{{ Tocountry.content.country }}</span>
            <!-- <span
              v-if="langSet == 'en' && item.en_country.length > 0"
              :class="[countrytext == item.en_country ? 'active' : '']"
              @click="chooseCList(Tocountry.content.en_country,Tocountry.content,Tocountry.index)"
            >{{ Tocountry.content.en_country }}</span>-->
          </p>
        </div>
      </div>
    </div>

    <div class="masklist">
      <span class="masktitle">{{ $t("exhibitor.productGroups") }}</span>
      <div class="labelBox">
        <div
          :class="[
            productid == item.linkageid ? 'select' : '',
            'masklabel',
            'productlabel',
          ]"
          v-for="(item, index) in productType"
          :key="index"
          @click="choosePList(item.linkageid)"
        >
          <span>
            <b v-if="langSet == 'zh' || item.description.length == 0">
              {{
              item.name
              }}
            </b>
            <b v-if="langSet == 'en' && item.description.length > 0">
              {{
              item.description
              }}
            </b>
            <i
              v-if="item.child.length > 0 && productid == item.linkageid"
              class="el-icon-arrow-down"
            ></i>
            <i v-if="item.child.length > 0 && productid != item.linkageid" class="el-icon-plus"></i>
          </span>
          <div class="submasknav" v-if="item.child.length > 0">
            <i class="el-icon-caret-top"></i>
            <p v-for="(_item, _index) in item.child" :key="_item.id">
              <span
                v-if="langSet == 'zh' || _item.description.length == 0"
                :class="[_item.show ? 'active' : '']"
                @click.stop="levelClick(_item,index,_index)"
              >{{ _item.name }}</span>
              <span
                v-if="langSet == 'en' && _item.description.length > 0"
                :class="[_item.show ? 'active' : '']"
                @click.stop="levelClick(_item,index,_index)"
              >{{ _item.description }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="masklist">
      <span class="masktitle">{{ $t("exhibitor.countryRegion") }}</span>
      <div class="masklabel">
        <p v-for="(item, index) in countryList" :key="item.id">
          <span
            v-if="langSet == 'zh' || item.en_country.length == 0"
            :class="[countrytext == item.country ? 'active' : '']"
            @click="chooseCList(item.country,item,index)"
          >{{ item.country }}</span>
          <span
            v-if="langSet == 'en' && item.en_country.length > 0"
            :class="[countrytext == item.en_country ? 'active' : '']"
            @click="chooseCList(item.en_country,item,index)"
          >{{ item.en_country }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { getProductList, getAll, getCountry, countrytext } from "@/api/api";
export default {
  components: {},
  props: {
    newgetList: Function,
  },
  data() {
    return {
      input: "",
      isShow: false,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        grabCursor: true,
      },
      navList: [],
      current: -1,
      col: 4,
      list: [],
      keywords: "",
      companyid: "",
      page: "1",
      pagesize: 20,
      productClass_1: "",
      productClass_2: "",
      total: 0,
      productType: [],
      countryList: [],
      productid: -1,
      subMenuid: -1,
      langSet: "",
      placeholder: "",
      countrytext: "",
      ToChoose: {
        content: {},
        index: -1,
        _index: -1,
      },
      Tocountry: {
        content: {
          country: "",
          en_country: "",
        },
        index: -1,
      },
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.placeholder = this.$t("exhibitor.placeholderProduct");
    this.memberid = localStorage.getItem("memberid");
    this.getList();
    this.getAllList(3360);
    this.getCountryList();
    let nav = this.$qs.stringify({
      keyid: "3360",
    });
    this.getNav(nav);
  },
  methods: {
    changeNav(index, id) {
      this.current = index;
      this.productClass_1 = id;
      this.getList();
    },
    search() {
      //console.log(this.keywords)
      if (this.keywords == 0) {
        this.$message("请输入产品名称");
        return false;
      }
      this.getList();
    },
    getNav(data) {
      getAll(data)
        .then((res) => {
          //console.log(res)
          if (res.data.errno == 0) {
            this.navList = res.data.rst.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList() {
      let data = this.$qs.stringify({
        keywords: this.keywords,
        memberid: this.memberid,
        companyid: this.companyid,
        productClass_1: this.productClass_1,
        productClass_2: this.productClass_2,
        pagesize: this.pagesize,
        page: this.page,
      });
      //console.log(data)
      getProductList(data)
        .then((res) => {
          console.log(res.data);
          if (res.data.errno == 0) {
            this.list = res.data.rst;
            this.total = Number(res.data.errmsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllList(keyid) {
      let data = this.$qs.stringify({
        keyid,
      });
      console.log(data);
      getAll(data)
        .then((res) => {
          //console.log(res.data.rst.data)
          if (res.data.errno == 0) {
            var productType = res.data.rst.data;
            productType.map((item) => {
              item.show = false;
              if (item.child) {
                item.child.map((ChildItem) => {
                  ChildItem.show = false;
                });
              }
            });
            console.log(productType)
            this.productType = productType;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCountryList() {
      getCountry()
        .then((res) => {
          console.log(res.data.rst);
          if (res.data.errno == 0) {
            this.countryList = res.data.rst;
            console.log(this.countryList);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    chooseCList(text, item, index) {
      console.log(text, item, index);
      if (this.countrytext != text) {
        console.log("/////");
        this.countrytext = text;
        var Tocountry = this.Tocountry;
        Tocountry = {
          content: item,
          index: index,
        };
        this.Tocountry = Tocountry;
      } else {
        this.countrytext = "";
        this.Tocountry = {
          content: {},
          index: -1,
        };
      }
      // var data =this.$qs.stringify({
      //   productClass_2:
      //   country: this.Tocountry.index>-1?this.Tocountry.content.country:'',
      //   pagesize: 4,
      //   page: 1
      // });
      // this.newgetList(data)
      this.changePage();
    },
    changePage(val) {
      this.page = val;
      var productType=this.productType;
      var Class_1=[];
      var Class_2=[];
      var Class_2Nama=[];
      var en_class_2name=[];
      console.log(productType)
      productType.map((class1Item)=>{
        class1Item.child.map((class2Item)=>{
          if(class2Item.show){
            Class_1.push(class2Item.parentid)
            Class_2.push(class2Item.linkageid)
            Class_2Nama.push(class2Item.description)
            en_class_2name.push(class2Item.description)
          }
        })
      })
      // description
      Class_1=Array.from(new Set(Class_1));
      console.log(Class_1,Class_2);
      let data = this.$qs.stringify({
        keywords: this.keywords,
        memberid: this.memberid,
        companyid: this.companyid,
        productClass_1: Class_1,
        // productClass_1: this.productid>-1?this.productid:'',
        productClass_2:Class_2,
        country:
          this.Tocountry.index > -1 ? this.Tocountry.content.country : "",
        pagesize: 9999,
        page: 1,
      });
      console.log(data);
      this.newgetList(
        data,
        Class_1,
        Class_2,
        this.Tocountry.index > -1 ? this.Tocountry.content.en_country : "",
        Class_2Nama,
        en_class_2name
      );
    },
    toDetail(id) {
      //console.log(id)
      this.$router.push({
        name: "prodetail",
        query: { id },
      });
    },
    choosePList(id) {
      if (this.productid != id) {
        this.productid = id;
      } else {
        this.productid = -1;
      }
    },
    levelClick(_item, index, _index) {
      var intshow=!_item.show
      console.log(_item);
      var productType = this.productType;
      // productType.map((fItem)=>{
      //   fItem.child.map((cItem)=>{
      //     cItem.show=false
      //   })
      // })
      productType[index].child[_index].show = intshow;
      this.productType = productType;
      // if (this.subMenuid != _item.linkageid) {
      //   this.subMenuid = _item.linkageid;
      //   var ToChoose = this.ToChoose;
      //   ToChoose = {
      //     content: _item,
      //     index: index,
      //     _index: _index
      //   };
      //   this.ToChoose = ToChoose;
      // } else {
      //   this.ToChoose = {
      //     content: {},
      //     index: -1,
      //     _index: -1,
      //   };
      //   this.subMenuid = -1;
      // }
      this.changePage();
    },
    reset() {
      this.productid = -1;
      this.subMenuid = -1;
    },
    searchBtn() {
      this.current = -1;
      this.isShow = false;
      this.productClass_1 = this.productid;
      this.productClass_2 = this.subMenuid;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.labelBox {
  display: inline-block;
}
.masklabel p {
  display: inline-block;
}
.product-swiper-container {
  line-height: 46px;
  height: 46px;
  margin: 19px 0 16px;
}
.product-swiper-container .swiper-slide {
  width: auto;
  padding-right: 45px;
  color: #666;
  font-size: 22px;
}
.product-swiper-container .swiper-slide .active {
  font-size: 24px;
  color: #CAC28A;
}

.pro-item-wrap {
  column-count: 4;
  column-gap: 10;
  margin-bottom: 25px;
  min-height: 500px;
}
.pro-item {
  width: 100%;
  margin-bottom: 25px;
  cursor: pointer;
  break-inside: avoid;
}
.pro-item img {
  width: 100%;
  border-radius: 20px;
}
.pro-item .pro-title {
  font-size: 16px;
  color: #000;
  font-weight: 600;
  line-height: 24px;
}
.pro-item .pro-company {
  font-size: 14px;
  color: #999;
  line-height: 18px;
}

.maskwrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}
.maskmain {
  width: 800px;
  background: #fff;
  padding: 27px 50px 77px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  height: 70%;
  overflow-y: scroll;
}
.maskmain .masktitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.masklist {
  margin-bottom: 50px;
  padding: 0 20px;
}
.masklist .masklabel span {
  background: rgba(238, 238, 238, 1);
  border-radius: 4px;
  display: inline-block;
  padding: 5px 10px;
  color: #000;
  cursor: pointer;
  margin: 10px 10px 0 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.masklist .masklabel span.active {
  background: #bbc080;
  color: #fff;
}
.maskbtn {
  display: flex;
  justify-content: center;
}
.maskbtn span {
  display: inline-block;
  cursor: pointer;
  width: 153px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  color: #fff;
  background: #CAC28A;
  border-radius: 3px;
}
.masklist .masklabel span > i {
  font-size: 14px;
  position: relative;
  top: 0px;
}
.maskbtn span.reset {
  background: #CAC28A;
  color: #000;
  margin-right: 26px;
}
.productlabel {
  display: inline-block;
}
.productlabel.select > span {
  background: #bbc080;
  color: #fff;
}
.productlabel.select .submasknav {
  display: flex;
  flex-wrap: wrap;
}
.submasknav {
  display: none;
  background: #f8f8f8;
  padding: 10px 10px 20px 10px;
  margin-top: 16px;
  position: relative;
  width: 700px;
}
.submasknav i {
  position: absolute;
  top: -15px;
  color: #fff2f2;
  font-size: 22px;
}
.masklist .masklabel .submasknav span {
  background: #fff;
  cursor: pointer;
}
.masklist .masklabel .submasknav span.active {
  background: #bbc080;
  color: #fff;
}
.moblie-filter {
  display: none;
}
@media only screen and (max-width: 767px) {
  .pro-item-wrap {
    column-count: 2;
    margin-top: 0.2rem;
  }
  .pro-item {
    width: 100%;
    margin-bottom: 0.25rem;
  }
  .product-swiper-container .swiper-slide {
    font-size: 18px;
    padding-right: 0.2rem;
  }
  .product-swiper-container .swiper-slide .active {
    font-size: 20px;
  }
  .companyWrap {
    margin-top: 0.36rem;
  }
  .product-swiper-container {
    display: none;
  }
  // 分页
  .companywrap .el-pagination {
    padding: 0.05rem;
    height: 0.5rem;
  }
  .companywrap .el-pagination button,
  .companywrap .el-pagination span:not([class*="suffix"]),
  .companywrap .el-pager li {
    font-size: 12px;
  }
  .companywrap .el-pagination button,
  .companywrap .el-pagination span:not([class*="suffix"]) {
    height: 0.36rem;
    line-height: 0.4rem;
  }
  .companywrap .el-pagination.is-background .el-pager li {
    width: 0.4rem;
    height: 0.4rem;
    line-height: 0.4rem;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 0;
    margin: 0 0.03rem;
  }
  .companywrap .el-pagination .btn-next .el-icon,
  .companywrap .el-pagination .btn-prev .el-icon {
    font-size: 12px;
    line-height: 0.4rem;
  }
  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    margin-right: 0;
  }
  // 分页
  .companylist {
    padding: 10px 15px;
    background: #fff;
    border: 0 none;
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    .logo {
      width: 0.98rem;
      height: 0.98rem;
      border: 0 none;
    }
    .middle {
      padding-left: 0.2rem;
      p {
        font-size: 12px;
      }
      .title {
        font-size: 14px;
        line-height: 18px;
      }
    }
    .right {
      display: none;
    }
  }
  .maskmain {
    width: 80%;
    height: 60%;
    overflow-y: scroll;
    padding: 0.2rem;
    border-radius: 10px;
    .el-icon-close {
      font-size: 30px !important;
      display: block;
      text-align: right;
    }
    .masktitle {
      font-size: 16px;
    }
    .masklist {
      margin-bottom: 0.5rem;
      .masklabel {
        span {
          font-size: 14px;
        }
      }
    }
    .maskbtn span {
      width: 2rem;
    }
  }
  .submasknav {
    width: 95%;
  }
  .choosewrap {
    .choosebtn,
    .search {
      display: none;
    }
    .el-input {
      width: 3rem;
    }
    .el-input__inner {
      width: 3rem;
      height: 0.6rem;
      font-size: 12px;
    }
    .el-input__icon {
      font-size: 16px;
      line-height: 0.6rem;
    }
    .el-input__prefix {
      left: 0;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 0.4rem;
      padding-right: 0.1rem;
    }
  }
  .moblie-filter {
    display: block;
    flex: 1;
    font-size: 12px;
    color: #303030;
    text-align: right;
    line-height: 0.6rem;
    img {
      width: 0.28rem;
      margin-right: 0.1rem;
      position: relative;
      top: 0.05rem;
    }
  }
}
</style>